import React from 'react';
import type { IssueSeverity } from './types';

const SEV_CONFIG: Record<IssueSeverity, { bg: string; text: string }> = {
  HIGH:   { bg: 'bg-[#FEE2E2]', text: 'text-[#991B1B]' },
  MEDIUM: { bg: 'bg-[#FEF3C7]', text: 'text-[#92400E]' },
  LOW:    { bg: 'bg-[#EDE9FE]', text: 'text-[#4C1D95]' },
};

const SeverityBadge: React.FC<{ severity: IssueSeverity }> = ({ severity }) => {
  const config = SEV_CONFIG[severity] || SEV_CONFIG.MEDIUM;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-bold uppercase tracking-wide ${config.bg} ${config.text}`}>
      {severity}
    </span>
  );
};

export default SeverityBadge;
